export const delay = (delayTimeInMs: number): Promise<void> => {
    return new Promise<void>(resolve => {
        setTimeout(resolve, delayTimeInMs);
    });
};
